
export const FAST_DEP_REGISTRATION_SEGMENT = 'FAST_DEP_REGISTRATION_SEGMENT';
export const FAST_DEP_REGISTRATION_BANNER = 'FAST_DEP_REGISTRATION_BANNER';
